import {
  AppSyncFarm,
  AppSyncFarmToken,
  MonitorVaults,
} from 'common/models/farm';
import React from 'react';
import { FarmUtils } from 'utils/farmUtils';
import { AppSyncUserInfo } from 'common/models/userInfo';
import FormatNumber from '../FormatPercent/FormatNumber';
import { LinkButton } from '../LinkButton/LinkButton';
import { TokenIcon } from '../TokenIcons/TokenIcon';
import { ChainId } from 'constants/constants';

type Props = {
  token: AppSyncFarmToken;
  farms: AppSyncFarm[] | [];
  userInfoLoading: boolean;
  userInfo: AppSyncUserInfo;
  claiming: boolean;
  isIchiVault: boolean;
  monitorVaults: MonitorVaults[] | [];
};

const VaultsTablePosition: React.FC<Props> = (props) => {
  const baseToken = props.token;
  const farms = props.farms.filter(
    (v) => FarmUtils.getBaseToken(v).address === baseToken.address
  );
  const farm = farms[0];

  const aprs = farms
    .map(
      (v) =>
        FarmUtils.getFeeAprByVaultAddress(props.monitorVaults, v.lpAddress) ?? 0
    )
    .sort((a, b) => b - a);
  const apr = aprs[0];

  const isEthVault =
    baseToken?.displayName === 'wETH' && farm.chainId !== ChainId.Polygon &&
    farm?.chainId !== ChainId.Celo;
  const baseTokenDisplayName = isEthVault ? 'ETH' 
    : (baseToken?.displayName === 'ETHC' ? 'ETH': baseToken?.displayName);

  const actionButtonCaption = 'Earn';

  return (
    <>
      {/* Deposit Token */}
      <td key="deposit-token" className="primary-text-color">
        <div className="flex flex-col gap-1 tablet:flex-row items-left tablet:items-center max-w-max">
          <TokenIcon name={baseToken.name} height="40px" width="40px" />
          <div className="coin-name ml-0 tablet:ml-3 ">
            {baseTokenDisplayName}
          </div>
        </div>
      </td>

      {/* ROI */}
      <td key="roi" className="primary-text-color">
        {/* Don't show 0% IRR and IRR > 1,000% */}
        {apr > 0.01 && apr < 1000 ? (
          <FormatNumber value={apr} postfix="%" isLoading={false} />
        ) : (
          <></>
        )}
      </td>

      {/* Actions Column */}
      <td key="actions" className="text-right w-20 tablet:w-44">
        <LinkButton
          to={`/vault/token/${baseToken.address.toLowerCase()}`}
          id={farm.poolId.toString()}
          className="w-16 tablet:w-40 mr-3 tablet:mr-4"
          styleClass=""
        >
          {actionButtonCaption}
        </LinkButton>
      </td>
    </>
  );
};

export default VaultsTablePosition;
